import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateWarrantyForm from '../../../modules/warranties/components/CreateWarrantyForm';
import { useParams } from 'react-router-dom';

const CreateWarranty = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_warranty') : t('create_warranty');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/warranties/create-warranty' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateWarrantyForm />
    </div>
  );
};

export default CreateWarranty;
